import React from 'react'
import './motor-carrier-insurance.scss'
import {
    Hero, MainHeading,
    Breadcrumb, CommonTabs,
    SentryCard, Plans,
    NewsCard, SuccessStories,
    FindAgent,
    PageHeaderIntro
} from '../../../../components';
import { images } from "../../../../utils/customFn";
import { Container } from 'react-bootstrap';

const MotorCarrierInsurance = () => {
    const breadcrumbs = [
        { label: "Sentry Insurance home", link: "/" },
        { label: "What we offer", link: "/what-we-offer" },
        { label: "Insurance products", link: "/what-we-offer/insurance-products" },
        { label: "Business auto insurance", link: "/what-we-offer/insurance-products/business-auto-insurance" },
        { label: "Motor carrier insurance", link: "/what-we-offer/insurance-products/business-auto-insurance/motor-carrier-insurance" },
    ];

    const activeTabId = "difference";

    const tabsData = [
        {
            id: "difference",
            href: "#/",
            label: "The Sentry difference",
        },
        {
            id: "coverages",
            href: "#/",
            label: "Insurance solutions for motor carriers",
        },
        {
            id: "help",
            href: "#/",
            label: "Who we've helped",
        },
    ];

    const sectrydata = {
        banner: images['two_business_people_looking_at_tablet.avif'],
        heading: 'The Sentry difference',
        subheading: 'Different drivers—different coverages',
        para: 'We’ll work with you to determine what liability insurance coverage is appropriate for your organization. Our goal is to help make sure you’re protected from the actual exposures and risks your business faces.',
        sideheading: 'The right coverage for your business',
        sidepara: 'We draw on our insurance experience and leverage our industry knowledge to help you protect your business and your future.',
        sideImg: images['boots_Blue.svg']
    }
    const plansData = {
        blue_heading: 'Specific policies and coverages for motor carriers',
        blue_para: 'Do your employees occasionally use rented vehicles for company business? We offer insurance for that. We can also protect you from losses due to bodily injury or physical damage caused by an employee, loss-of-use expenses due to the theft of a company vehicle, and the loss of personal effects in a stolen company vehicle. We can help you be proactive and prepared with your insurance coverage. Let’s work together to keep your business moving.',
        purple_icon: images['Icon_of_two_orange_boots.svg'],
        purple_heading: 'We can help you improve safety',
        purple_para: "Our transportation safety services associates have the industry knowledge and experience to help you identify risks and implement safety procedures.",
    }
    const NewsCardData = [
        {
            id: 1,
            title: 'Commercial auto insurance',
            description:
                'We have the 401(k) and other retirement plan options and services to help you and your employees plan for retirement.',
            linkUrl: '',
            linkText: 'More about commercial auto insurance >',
        },
        {
            id: 2,
            title: 'Dealership auto coverage',
            description: 'Running a business comes with uncertainties. Protect yourself from the unknown with business liability coverage.',
            linkUrl: '/',
            linkText: 'More about dealership auto coverage >',
        },
        {
            id: 3,
            title: 'Commercial auto liability',
            description:
                'Protect your profits and property from the unexpected during a construction or renovation project.',
            linkUrl: '/',
            linkText: 'More about commercial auto liability >',
        },

    ];
    const HeaderData = [
        {
            image: images['Icon_of_two_people_shaking_hands.svg'],
            para: 'You have people counting on you to keep your commitments. That’s why you take protecting your employees and your cargo seriously. We appreciate your commitment to safety, because we understand the exposures you face. We can help protect what’s important to you—your employees, your fleet, and your cargo. Scroll down to learn more about our insurance solutions for motor carriers.',
        },
    ];
    return (
        <>
            <div className='motor-carrier-insurance'>
                {/* hero section */}
                <Hero img={images["White_semi_trailer_trucks_driving_down_highway.avif"]} />
                <Container>
                    {/* Breadcrumb */}
                    <Breadcrumb crumbs={breadcrumbs} />
                    {/* heading  */}
                    <MainHeading title="Motor carrier insurance" showshare={false} />
                    {/* Tabs */}
                    <CommonTabs tabs={tabsData} activeTab={activeTabId} />

                    {/* Header intro section */}
                    <PageHeaderIntro Data={HeaderData} heading="" />

                    {/* the sentry card */}
                    {/* <SentryCard data={sectrydata} /> */}
                    {/* Plans section */}
                    <div className='the-sentry-card'>
                      <h1>The Sentry difference</h1>
                      <Plans data={plansData} />
                    </div>
                    {/* news card section */}
                    <NewsCard Title="Insurance solutions for motor carriers" CardData={NewsCardData} showNavLink={false} subTitle="PRODUCTS" />
                    {/* success stories */}
                    <SuccessStories showSeemore={true} />
                    {/* news  */}
                    <NewsCard Title="News and resources" CardData={NewsCardData} showNavLink={false} subTitle="GUIDES" />
                    <FindAgent />
                </Container>
            </div>
        </>
    )
}

export default MotorCarrierInsurance